/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Lean_Ape_StirInputs */

const en_soft_lean_ape_stir = /** @type {(inputs: Soft_Lean_Ape_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surveys`)
};

const de_soft_lean_ape_stir = /** @type {(inputs: Soft_Lean_Ape_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Befragungen`)
};

/**
* | output |
* | --- |
* | "Surveys" |
*
* @param {Soft_Lean_Ape_StirInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_lean_ape_stir = /** @type {((inputs?: Soft_Lean_Ape_StirInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Lean_Ape_StirInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_lean_ape_stir(inputs)
	return de_soft_lean_ape_stir(inputs)
});